const KEY = 'stratus_chat_cid';
const TTL_MS = 24 * 60 * 60 * 1000;

interface Stored {
  id: string;
  createdAt: number;
}

export function getConversationId(): string | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<Stored>;
    if (!parsed.id || typeof parsed.createdAt !== 'number') return null;
    if (Date.now() - parsed.createdAt > TTL_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return parsed.id;
  } catch {
    return null;
  }
}

export function setConversationId(id: string): void {
  try {
    localStorage.setItem(KEY, JSON.stringify({ id, createdAt: Date.now() } satisfies Stored));
  } catch {
    /* localStorage disabled — silently degrade */
  }
}

export function clearConversationId(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
